<template>
  <v-layout>404 Not Found</v-layout>
</template>

<script setup>

</script>

<style scoped>

</style>
